<input class="sem-time-picker" type="time" [disabled]="checkForDisabled(getAttribute('name'))" (input)="onTextChange($event.target.value)" 
[(ngModel)]="value" [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field': checkForDisabled(getAttribute('name')) }"/>
<!-- *ngIf="!evaluateConditionForHiding(condition,model)" -->
<!--<p class="binding-prop-name">{{getAttribute('name')}}</p> -->
